'use strict';
module.exports = {
  BOOTSTRAP: 'wix_code_worker_bootstrap',
  BOOTSTRAP_DONE: 'worker_bootstrap_done',
  LOAD_USER_CODE: 'wix_code_worker_load_user_code',
  LOAD: 'wix_code_worker_load',
  INIT: 'wix_code_worker_init',
  START: 'wix_code_worker_start',
  PAGE_RENDERED: 'trigger_onRender',
  UPDATE_WIX_CODE_DATA_AFTER_LOGIN: 'update_wix_code_model_data_after_login',
  REQUEST_API: 'REQUEST_API',
  PLATFORM_PUBLIC_API_PREFIX: 'viewer_platform_public_api_',
  SCRIPT_IMPORT_MESSAGE: 'script_import_message'
};



// WEBPACK FOOTER //
// ./src/main/worker/MessageType.js